import { useTranslation } from "react-i18next";
import { useTheme } from "../../../context/ThemeContext";
import SolarMoonBoldDuotone from "../../icons/SolarMoonBoldDuotone";
import SolarSun2BoldDuotone from "../../icons/SolarSun2BoldDuotone";

const ThemeLink = () =>{

    const { darkTheme, setDarkTheme } = useTheme();
    const { t } = useTranslation();
    
    const handleClickTheme = () => {
        setDarkTheme(!darkTheme)
    }

    return (
        <span className="dropdown-item cursor-pointer"
            onClick={handleClickTheme}>
            <div>   
                {darkTheme 
                ? (<><SolarSun2BoldDuotone className="text-muted"/>{t('ThemeLink.light')}</>)
                : (<><SolarMoonBoldDuotone className="text-muted"/>{t('ThemeLink.dark')}</>)} 
            </div>
        </span>
    )
}

export default ThemeLink;